import React from "react";
import {TableContainer} from "./styles";
import {NavigationButton} from "../../layouts/DataTableLayout/styles";
import {ReactComponent as ArrowLeft} from "../../assets/icons/arrow-left.svg";
import {ReactComponent as ArrowRight} from "../../assets/icons/arrow-right.svg";
import {PaginationSummary} from "../../utils";
import {FlexRow} from "../FlexRow";

export const Table = ({children}: any) => {
    return <TableContainer>{children}</TableContainer>
}

export const TableHeader = ({children}: any) => {
    return <thead>
    <tr>
        {children}
    </tr>
    </thead>
}

export const TableBody = ({children}: any) => {
    return <tbody>{children}</tbody>
}

export interface TableNavigationProps{
    pageLimit: number,
    summary: PaginationSummary,
    setPage?: Function
}

export const TableNavigation = ({setPage, pageLimit, summary}: TableNavigationProps) => {

    const handlePreviousPage = () => setPage ? setPage((prevState:number) => prevState - 1) : null
    const handleNextPage = () => setPage ? setPage((prevState:number) => prevState + 1) : null

    return  <FlexRow align="center">
        <p style={{marginRight: '30px'}}> {summary.from}-{summary.to} of {summary.total} </p>
        {summary.total > pageLimit && <FlexRow>
            <NavigationButton
                disabled={!summary.hasPreviousPage}
                style={{marginRight: '30px'}}
                onClick={handlePreviousPage}
            >
                <ArrowLeft/>
            </NavigationButton>
            <NavigationButton
                disabled={!summary.hasNextPage}
                onClick={handleNextPage}
            >
                <ArrowRight/>
            </NavigationButton>
        </FlexRow>}
    </FlexRow>
}
